import React from 'react';

import { SVGComponentProps } from './svg.types';

const EmailAtTheRateSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 13 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...otherProps}
      >
        <path
          d="M6.31222 12.1681C8.42544 12.1681 10.2368 11.3173 11.1424 10H9.89372C9.19389 10.6587 7.95889 11.2213 6.36711 11.2213C3.16983 11.2213 1.55061 9.17667 1.55061 6.56944C1.55061 3.4545 3.77361 1.4785 6.60039 1.4785C9.37228 1.4785 11.1424 3.09772 11.1424 5.48539C11.1424 7.50256 10.4014 8.29844 9.64672 8.29844C9.15272 8.29844 8.97433 7.96911 9.04295 7.39278L9.5095 3.64661H7.49233L7.39628 4.36017C7.19045 3.90733 6.75133 3.53683 5.90056 3.53683C4.39111 3.53683 3.18356 4.82672 3.18356 6.76156C3.18356 8.33961 4.0755 9.31389 5.42028 9.31389C6.2985 9.31389 6.90228 8.8885 7.25906 8.16122C7.45117 8.8885 8.08239 9.28644 9.27622 9.28644C10.7445 9.28644 12.2402 8.24356 12.2402 5.51283C12.2402 2.50767 9.82511 0.517944 6.57294 0.517944C3.3345 0.517944 0.384222 2.91933 0.384222 6.55572C0.384222 9.65694 2.60722 12.1681 6.31222 12.1681ZM6.07894 7.69467C5.53006 7.69467 5.24189 7.25556 5.24189 6.67922C5.24189 5.75983 5.681 5.12861 6.2985 5.12861C6.87483 5.12861 7.17672 5.49911 7.17672 6.10289C7.17672 7.04972 6.68272 7.69467 6.07894 7.69467Z"
          fill={fill}
        />
      </svg>
    </span>
  );
};

export default EmailAtTheRateSVG;
